import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { salesApi, SALES_TOKEN_KEY } from './salesApi';

const AuthContext = createContext({ user: null, login: async () => {}, logout: () => {}, refresh: async () => {} });

export function SalesAuthProvider({ children, onLanguage }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(SALES_TOKEN_KEY)) { setUser(false); return; }
    try {
      const { data } = await salesApi.get('/auth/me');
      setUser(data);
      if (data?.language && onLanguage) onLanguage(data.language);
    } catch (e) {
      setUser(false);
    }
  }, [onLanguage]);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    const handler = () => setUser(false);
    window.addEventListener('sales-logout', handler);
    return () => window.removeEventListener('sales-logout', handler);
  }, []);

  const login = async (username, password) => {
    const { data } = await salesApi.post('/auth/login', { username, password });
    localStorage.setItem(SALES_TOKEN_KEY, data.access_token);
    setUser(data.user);
    if (data.user?.language && onLanguage) onLanguage(data.user.language);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(SALES_TOKEN_KEY);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, refresh }}>{children}</AuthContext.Provider>;
}

export const useSalesAuth = () => useContext(AuthContext);
